import { isValidElement, type ReactElement } from "react";

/** Whether an overlay trigger element is rendered with `disabled`. */
export const isDisabledElement = (element: ReactElement) =>
    isValidElement<{ disabled?: boolean }>(element) &&
    element.props.disabled === true;
